import { permissionsApiSlice } from "features/api/permissionsApi";
import { accountApiSlice } from "features/api/accountApi";
import { leadGenApiSlice } from "features/LeadGen/api/leadGenApi.ts";
import { dashboardApiSlice } from "features/Dashboard/api/dashboardApi.ts";

/**
 * Middleware that automatically invalidates tags across multiple slices
 * when billTos permissions are updated
 *
 * This ensures data stays in sync across the permissionsApi and accountApi slices
 */
export const crossSliceInvalidationMiddleware = (store: any) => (next: any) => (action: any) => {
	const result = next(action);

	// Check if this is a fulfilled update bill to email recipients mutation
	if (permissionsApiSlice.endpoints.updateBillToEmailRecipients.matchFulfilled(action)) {
		// Invalidate tags across slices
		store.dispatch(accountApiSlice.util.invalidateTags(["BillTo", "Accounts"]));
	}

	if (leadGenApiSlice.endpoints.updateLeadAssignment.matchFulfilled(action)) {
		store.dispatch(dashboardApiSlice.util.invalidateTags(["DashboardLeads"]));
	}

	return result;
};
